module.exports = __webpack_public_path__ + "img/360-foaje.4693575e.jpg";